export default __webpack_public_path__ + "static/media/blog-img221.6744b7e1.jpg";